import { COMPANYEMPLOYEE_SHIFT } from "../actions/types";

const initialState = {
  getCompanyEmployeeShift: {
    companyEmployeeShift: null,
    errorMessage: null,
    isFetching: false,
  },

  updateCompanyEmployeeShift: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },

  createReport: {
    successMessage: null,
    errorMessage: null,
    isFetching: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    // #region COMPANYEMPLOYEE_SHIFT.GET

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_REQUEST:
      return {
        ...state,
        getCompanyEmployeeShift: {
          companyEmployeeShift: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_SUCCESS:
      return {
        ...state,
        getCompanyEmployeeShift: {
          companyEmployeeShift: action.payload,
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_GET_FAIL:
      return {
        ...state,
        getCompanyEmployeeShift: {
          companyEmployeeShift: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region COMPANYEMPLOYEE_SHIFT.UPDATE

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_REQUEST:
      return {
        ...state,
        updateCompanyEmployeeShift: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_SUCCESS:
      return {
        ...state,
        updateCompanyEmployeeShift: {
          successMessage: "Medewerker van dienst wijzigen is voltooid.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_UPDATE_FAIL:
      return {
        ...state,
        updateCompanyEmployeeShift: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    // #region

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_REQUEST:
      return {
        ...state,
        createReport: {
          successMessage: null,
          errorMessage: null,
          isFetching: true,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_SUCCESS:
      return {
        ...state,
        createReport: {
          successMessage: "Rapportage indienen is gelukt.",
          errorMessage: null,
          isFetching: false,
        },
      };

    case COMPANYEMPLOYEE_SHIFT.COMPANYEMPLOYEE_SHIFT_CREATE_REPORT_FAIL:
      return {
        ...state,
        createReport: {
          successMessage: null,
          errorMessage: action.payload,
          isFetching: false,
        },
      };

    // #endregion

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/companyEmployeeShiftReducer.js